module.exports = __webpack_public_path__ + "static/media/classting-wordmark.f453f3fa.svg";